<template>
  <base-modal modal-content-class="rest confirm_purch">
    <div class="content">
      <h1>{{ $_getTranslations.home_modals_confirm_purchase_for_pin_error_title }}</h1>

      <p class="mt-40">{{ $_getTranslations.home_modals_confirm_purchase_for_pin_error_purchase_not_successful }}</p>

      <p>{{ $_getTranslations.home_modals_confirm_purchase_for_pin_error_description }}</p>

      <base-button @button:click="closeModal">
        {{ $_getTranslations.home_modals_confirm_purchase_try_again_button }}
      </base-button>
    </div>
  </base-modal>
</template>

<script>
import {mapMutations} from 'vuex'
import BaseModal from '../../../common/modal/BaseModal'
import BaseButton from '../../../common/button/BaseButton'
import translationMixin from '../../../../common/mixins/translation'
import modals from '../../../../common/modals'
// modal_operator_down_PIN
export default {
  name: 'confirm-purchase-for-pin-error',
  components: {
    BaseModal,
    BaseButton
  },
  mixins: [translationMixin],
  methods: {
    ...mapMutations('common', [
      'storeModalForStore'
    ]),
    closeModal () {
      modals.hideCommonModal({
        afterHideCallback: () => {
          this.storeModalForStore(null)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchaseForPinError.vue